// export const handleLinkByType = (link, type, push) => {
//   switch (type) {
//     case "url":
//       return push(link);
//     case "product":
//       return push(`/product/${link}`);
//     case "category":
//       return push(`/${link}`);
//     default:
//       return null;
//   }
// };
export const handleLinkByType = (link, type) => {
  let newUrl = null;
  switch (type) {
    case "url":
      newUrl = link;
      break;
    case "product":
      newUrl = link?.startsWith("/product/") ? link : `/product/${link}`;
      newUrl = newUrl.replace(/\/{2,}/g, '/');
      break;
    case "category":
      newUrl = link?.startsWith("/") ? link?.slice(0) : `/${link}`;
      newUrl = newUrl.replace(/\/{2,}/g, '/');
      break;
    default:
      newUrl = null;
  }
  return newUrl;
};

export const handleLinkByTypeV2 = (link, type) => {
  switch (type) {
    case "url":
      return link || '#';
    case "product":
      return link?.startsWith("/product/") ? link : `/product/${link}`;
    case "category":
      return link?.startsWith("/") ? link?.slice(0) : `/${link}`;
    default:
      return `#`;
  }
};

export const handleLinkLocale = (link, locale) => {
  //console.log("handleLinkLocale: ", link, type, locale);
  const baseUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
  if (link.startsWith(baseUrl)) {
    return locale === "ar" && link?.includes("/en")
      ? link?.replace("/en/", "/")
      : link;
  }
  return link;
};
